// @flow
import React from 'react';
import styled from 'styled-components';

const Loading = styled.div`
  position: fixed;
  z-index: 99;
  top: 0;
  left: 0;
  right: 0;
  opacity: 1;

  ${({ hide }) =>
    (hide
      ? `
      visibility: hidden;
      opacity: 0;
      transition: opacity 0.25s 0.25s ease-in, visibility 0s 0.5s ease-in;
    `
      : `
      opacity: 1;
      visibility: visible;
      transition: opacity 0.25s 0s ease-in, visibility 0s 0s ease-in;
    `)};
`;

const Bar = styled.div`
  width: 100%;
  height: 3px;
  box-shadow: ${({ theme }) => theme.boxShadow};
  background-color: ${({ theme }) => theme.terciaryColor};
  transform: translateX(${({ size }) => size - 100}%);
  transition: transform 0.15s ease-in-out;
`;

type Props = {
  loading: boolean
};

type State = {
  size: number,
  hide: boolean
};

export class LoadingBar extends React.Component<Props, State> {
  state = {
    size: 0,
    hide: true
  };

  calculateWidth = () => {
    const { size } = this.state;
    const newSize = size * 1.5;
    this.setState({
      size: this.state.hide ? 100 : newSize > 99 ? 99 : newSize
    });
    if (!this.state.hide) setTimeout(this.calculateWidth, 800);
  };

  UNSAFE_componentWillReceiveProps(nextProps: Props) {
    if (this.props.loading && !nextProps.loading) {
      this.setState({ size: 100, hide: true }, () => setTimeout(() => this.setState({ size: 10 }), 500));
    }
    if (!this.props.loading && nextProps.loading) {
      this.setState({ size: 10, hide: false }, this.calculateWidth);
    }
  }

  render() {
    const { size, hide } = this.state;

    return (
      <Loading hide={hide}>
        <Bar size={size} />
      </Loading>
    );
  }
}
